import { useEffect } from 'react';
import { useAuth } from '@/lib/auth';
import { useBusinessProfile } from '@/hooks/use-business-profile';
import { updateSentryUserContext, updateSentryBusinessContext } from '@/lib/sentry-utils';

/**
 * Hook to automatically update Sentry context with user and business data
 * This enables auto-population of feedback forms and better error tracking
 */
export function useSentryContext() {
  const { user } = useAuth();
  const { businessProfile } = useBusinessProfile();

  // Update Sentry user context when user changes
  useEffect(() => {
    updateSentryUserContext(user);
  }, [user]);

  // Update Sentry business context when business profile changes
  useEffect(() => {
    updateSentryBusinessContext(businessProfile);
  }, [businessProfile]);
}
